import { Component, OnInit } from '@angular/core';
import type { HomeDatosContent } from '../../models/home-datos-content.model';
import { HomeDatosService } from '../../services/home-datos.service';
import { buildHomeDatosFallback } from '../../utils/home-datos-metrics.mapper';

@Component({
  selector: 'app-home-datos',
  templateUrl: './home-datos.component.html',
  styleUrls: ['./home-datos.component.scss'],
  standalone: false,
})
export class HomeDatosComponent implements OnInit {
  content: HomeDatosContent = buildHomeDatosFallback();

  constructor(private readonly homeDatosService: HomeDatosService) {}

  ngOnInit(): void {
    this.homeDatosService.loadContent().subscribe((content) => {
      this.content = content;
    });
  }
}
